module.exports = __webpack_public_path__ + "static/media/close-selection.070428c4.svg";